module.exports = __webpack_public_path__ + "static/media/7bd03133bdaa9c78bee7def654bb78e94a9e6fe0-23x22.39779c9b.png";